module.exports = __webpack_public_path__ + "img/threeday1-2.1480ea08.jpg";